// ag-grid-type.component.ts
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { AgGridModule } from 'ag-grid-angular';

@Component({
  selector: 'formly-field-ag-grid',
  template: `
    <ag-grid-angular 
    (gridReady)="to['gridReady'] && to['gridReady']($event)"
      style="width: 500px; height: 500px;" 
      class="ag-theme-alpine" 
      [rowData]="to['rowData']" 
      [columnDefs]="to['columnDefs']">
    </ag-grid-angular>
  `,
  standalone:true,
  imports:[
    AgGridModule,

  ]
})
export class FormlyFieldAgGrid extends FieldType {
    rowData = [];
}
